import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';

import { PhClientModel } from '../model/index';

@Injectable()
export class PhClientService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private phClientUrl = 'api/phClient';  // URL to web api

    constructor(private http: Http, public toasterService: ToasterService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getClientList(query: any): Promise<PhClientModel[]> {
        let that = this,
            params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.phClientUrl}/clientList`;
        return this.http.get(url, options)
            .toPromise()
            .then(that.extractData,
            // Errors will call this callback instead:
            err => {
                var toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'Something went wrong!'
                };
                that.toasterService.pop(toast);
            })
            .catch(this.handleError);
    }

    getClient(client_id: number): Promise<PhClientModel> {
        const url = `${this.phClientUrl}/clientList?client_id=${client_id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as PhClientModel)
            .catch(this.handleError);
    }

    deleteClient(client_id: any): Promise<PhClientModel> {
        const url = `${this.phClientUrl}/deleteClient`;
        return this.http
            .post(url, $.param({ client_id: client_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PhClientModel)
            .catch(this.handleError);
    }

    addUpdateClient(clientData: any): Promise<any> {
        const url = `${this.phClientUrl}/addUpdateClient`;
        return this.http
            .post(url, $.param(clientData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    deletePhoto(agentData: any): Promise<any> {
        const url = `${this.phClientUrl}/deletePhoto`;
        return this.http
            .post(url, $.param(agentData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    searchRefClients(query: any): Promise<any> {
        const url = `${this.phClientUrl}/searchRefClients`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/phClient.service.ts